/**
 * How tall the Content Strategist message box is at rest, and while it is being written in.
 *
 * A permanently ten-row box is a lot of empty white between the conversation and the bottom of the
 * page; two rows is enough to show it takes prose. The height is only worth it once there is
 * something to put in it.
 */
export const RESTING_ROWS = 2;
export const WRITING_ROWS = 10;

/**
 * The one rule deciding the box's height, kept out of the component so it can be tested.
 *
 * `collapsedBySend` is the part that is not obvious. Sending with Enter leaves the caret in the
 * box, so focus alone would hold it open at ten rows over a field that was just emptied — the very
 * state the collapse exists for. The flag is set by a send and cleared by the next thing the user
 * does (typing, or re-entering the box), so it never outlives the send that caused it.
 *
 * Typed text wins over everything: a half-written message must not disappear behind a two-row
 * window just because something else on the page was clicked.
 */
export function composerRows(input: {
  value: string;
  focused: boolean;
  collapsedBySend: boolean;
}): number {
  if (input.value !== '') return WRITING_ROWS;
  return input.focused && !input.collapsedBySend ? WRITING_ROWS : RESTING_ROWS;
}
